<nav role="navigation" aria-label="Breadcrumb" tabindex="-1" class="breadcrumb-card-root">
  <ul class="breadcrumb-list">
    <ng-container *ngFor="let item of breadcrumbs; let i = index">
      <li
        *ngIf="item.show"
        [ngClass]="{ active: breadcrumbs.length - 1 === i }"
        class="breadcrumb-item-li"
        aria-current="page"
      >
        <ng-container *ngIf="item.isLink && (i === 1 || i===0)">
          <a
            *ngIf="item.resolve | async as title; else loading"
            [routerLink]="item.routeLink"
            class="link-a"
            >{{ title }}</a
          >
        </ng-container>
        <ng-container *ngIf="item.isLink && i > 1 ">
          <a
          *ngIf="fixed.includes(item.value)"
          [routerLink]="item.routeLink"
          class="link-a"
          >{{ item.value | titlecase }}</a
        > 
          <a *ngIf="!fixed.includes(item.value)" [routerLink]="item.routeLink" class="link-a">
            <ng-container *ngIf="item.resolve | async as title; else loading">
              {{ title }}
            </ng-container>
          </a>
         
        </ng-container>
        <ng-container *ngIf="!item.isLink">
          <ng-container *ngIf="item.resolve | async as title; else loading">
            <span class="not-link-a">{{ title }}</span>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="item.actionBtn && item.actionBtn.state">
          <a
            [routerLink]="item.actionBtn.routeLink"
            [matTooltip]="item.actionBtn.tooltip"
            class="link-a"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              aria-hidden="true"
              role="img"
              width="20"
              height="20"
              preserveAspectRatio="xMidYMid meet"
              viewBox="0 0 1024 1024"
            >
              <path
                fill="currentColor"
                d="M832 512a32 32 0 1 1 64 0v352a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32h352a32 32 0 0 1 0 64H192v640h640V512z"
              />
              <path
                fill="currentColor"
                d="M469.952 554.24l52.8-7.552L847.104 222.4a32 32 0 1 0-45.248-45.248L477.44 501.44l-7.552 52.8zm422.4-422.4a96 96 0 0 1 0 135.808l-331.84 331.84a32 32 0 0 1-18.112 9.088L436.8 623.68a32 32 0 0 1-36.224-36.224l15.104-105.6a32 32 0 0 1 9.024-18.112l331.904-331.84a96 96 0 0 1 135.744 0z"
              />
            </svg>
          </a>
          <!-- [class]="item.actionBtn.icon" -->
        </ng-container>
      </li>
    </ng-container>
  </ul>
</nav>

<ng-template #loading> ... </ng-template>
